const isBrowserEnvironment = () => (
  typeof window !== 'undefined'
);

const supportsLocalStorageApi = () => (
  'localStorage' in window
);

const supportsFetchApi = () => (
  'fetch' in window
);

const supportsNavigatorApi = () => (
  'navigator' in window
);

const supportsSendBeaconApi = () => supportsNavigatorApi() && ('sendBeacon' in window.navigator);

const supportsPerformanceApi = () => (
  'performance' in window
);

const supportsMatchMediaApi = () => isBrowserEnvironment() && typeof window.matchMedia !== 'undefined';

const supportsEnvironment = isBrowserEnvironment;

const supportsBeaconOrFetch = () => supportsSendBeaconApi() || supportsFetchApi();

const supportsPreloadState = () => isBrowserEnvironment() && '__PRELOADED_STATE__' in window;

const supportsWeakSet = () => 'WeakSet' in window;

module.exports = {
  supportsEnvironment,
  supportsNavigatorApi,
  supportsPerformanceApi,
  supportsBeaconOrFetch,
  supportsFetchApi,
  supportsMatchMediaApi,
  supportsPreloadState,
  supportsWeakSet,
  supportsLocalStorageApi,
};
